<app-view-induction [tableData]="Employees"></app-view-induction>
